import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken, useGetData } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";


//get all users
export const getOneUser = createAsyncThunk(
    "/usersSlice/getOneUser",
    async (id='') => {
        try {
            const response = await useGetData(`/api/v1/clients/${id}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const editUser = createAsyncThunk(
    
    "/usersSlice/editUser",
    async ({id='', data}) => {
        try {
            const response = await useUpdateData(`/api/v1/clients/${id}`, data);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getVerificationCode = createAsyncThunk(
    "/usersSlice/getVerificationCode",
    async (id='') => {
        try {
            const response = await useGetData(`/api/v1/clients/resetVerificationCode`);
            notify(t('updateSuccess'),"success")
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else if(error.response){
                console.log("111",error.response.data.message)
                return notify(error.response.data.message,"error");

            }
        }
    }
);


export const login=createAsyncThunk(
    "/usersSlice/login",
    async({data})=>{
        try {
            const response=await useInsertData('/api/v1/clients/login', data);
            console.log('res',response);
            return response;
        } catch (error) {
           // console.log('uuuuuuuuuuuuuuu',error.response.data);
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else if (error.response) {
            notify(error.response.data.message || "An error occurred", "error");
          }
          else  {
   
                return notify(" حدث خطأ اثناء الاضافة من فضلك اكمل البيانات","error");
        }
            
        }
    }
);


export const register = createAsyncThunk(
    "/usersSlice/register",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData('/api/v1/clients/register', data);
            console.log('res', response);

            // Navigate after successful response
        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error.response) {
                notify(error.response.data.message ,"error")
                return rejectWithValue(error.response.data.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);
export const verifyEmail = createAsyncThunk(
    "/usersSlice/verifyEmail",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await useInsertData('/api/v1/clients/verifyEmail', data);
            console.log('res', response);

            // Navigate after successful response
        

            return response;
        } catch (error) {
            console.log("error", error);

            if (error.message === "Network Error") {
                 rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ");
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");

            } else if (error.response) {
                notify(error.response.data.message ,"error")
                return rejectWithValue(error.response.data.message || "An error occurred");
            } else {
                return rejectWithValue("حدث خطأ اثناء الاضافة من فضلك اكمل البيانات");
            }
        }
    }
);

export const getSettings = createAsyncThunk(
    "/usersSlice/getSettings",
    async (id='') => {
        try {
            const response = await useGetData(`/api/v1/settings`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getConditions = createAsyncThunk(
    "/usersSlice/getConditions",
    async () => {
        try {
            const response = await useGetData(`/api/v1/settings/getConditions`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify("حدث خطأ حاول مرة اخري ", "error");
        }
    }
);
export const setContactUs = createAsyncThunk(
    "/usersSlice/setContactUs",
    async (data) => {
        try {
            const response = await useInsertData(`/api/v1/settings/contactUs`,data);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify("حدث خطأ حاول مرة اخري ", "error");
        }
    }
);
export const getRateQuestions = createAsyncThunk(
    "/usersSlice/getRateQuestions",
    async (query) => {
        try {
            const response = await useGetData(`/api/v1/rates/questions?${query}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return
        }
    }
);
export const Addrate = createAsyncThunk(
    "/usersSlice/Addrate",
    async (data) => {
        try {
            const response = await useInsertData(`/api/v1/rates`,data);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify("حدث خطأ حاول مرة اخري ", "error");
        }
    }
);
